import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Report } from "@/types";

interface ReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  report: Report | null;
}

const ReportModal: React.FC<ReportModalProps> = ({ isOpen, onClose, report }) => {
  if (!report) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {report.type === "detailed" ? "Detaylı Rapor" : "Genel Rapor"}
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4">
          <div className="p-4 border rounded-md bg-muted/50">
            <p className="text-sm text-muted-foreground">
              {report.type === "detailed"
                ? "Bu rapor, seçilen tarih aralığındaki tüm proje aktivitelerinin detaylı dökümünü içerir."
                : "Bu rapor, müşteriye sunulmak üzere proje aşamalarının genel bir özetini içerir."}
            </p>
          </div>

          {/* This would be populated with actual report preview in a real app */}
          <div className="mt-6 bg-card p-6 border rounded-md min-h-[300px] flex items-center justify-center">
            <p className="text-muted-foreground">Rapor önizleme burada gösterilecek</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReportModal;
